<template>
  <span>
    <img v-if="currentUrl" :src="currentUrl" :alt="name" :style="computedStyle" />
    <!-- 占位 -->
    <div v-else :style="computedStyle"></div>
  </span>
</template>

<script setup>
const props = defineProps({
  name: {
    type: String,
    required: true,
  },
  size: {
    type: [String, Number],
    default: '20px',
  },
  extension: {
    type: String,
    default: 'png',
  },
})

// 简单的缓存机制
const iconCache = new Map()
const currentUrl = ref('')
const isLoading = ref(false)

const computedStyle = computed(() => ({
  width: props.size,
  height: props.size,
}))

const loadIcon = async () => {
  const cacheKey = props.name

  // 检查缓存
  if (iconCache.has(cacheKey)) {
    currentUrl.value = iconCache.get(cacheKey)
    return
  }

  try {
    isLoading.value = true

    // 动态导入图标
    const module = await import(`@/assets/icons/${props.name}.${props.extension}`)
    const url = module.default

    // 缓存结果
    iconCache.set(cacheKey, url)
    currentUrl.value = url
  } catch (error) {
    console.error(`Failed to load icon: ${props.name}`, error)
    currentUrl.value = ''
  } finally {
    isLoading.value = false
  }
}

// 监听图标名称变化
watch(() => props.name, loadIcon, { immediate: true })

// 清理缓存（可选）
onUnmounted(() => {
  iconCache.clear()
})
</script>
